<template>
  <div class="account-icon" :style="accountIconStyle">
    <ImgLazy
      :image-url="iconImageUrl"
      alt-text="account icon"
      aspect-ratio="1"
      :width="size"
      :height="size"
    />
  </div>
</template>
<script>
import ImgLazy from '../images/ImgLazy.vue'
import NoneImage from '../../../../../../src/images/styleguide/none.png'
export default {
  components: {
    ImgLazy
  },
  props: {
    imageUrl: {
      type: String,
      required: false,
      default: ''
    },
    size: {
      type: Number,
      required: true
    }
  },
  computed: {
    isEmptyImageUrl() {
      return !this.imageUrl || this.imageUrl.length === 0
    },
    iconImageUrl() {
      return this.isEmptyImageUrl ? NoneImage : this.imageUrl
    },
    accountIconStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        'min-width': `${this.size}px`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.account-icon {
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
}
</style>
